import gql from 'graphql-tag';

export const removeDivisionMutation = gql`
	mutation RemoveDivision($id: ID!) {
		removeDivision(id: $id) {
			id
		}
	}
`;
